module.exports = __webpack_public_path__ + "img/map.5bed57a3.png";